import React from 'react';
import { useNavigate } from 'react-router-dom';
import { pathWithSessionId } from '../../utils/sessionManager';
import { HairSalonBrandLogo } from '../../utils/hairSalonFlowDeps';

export default function HairReportNav({
  onBack,
  onHome,
  sessionId,
  locationState,
  cartCount = 0,
  orgLogoUrl = '',
  showLogo = false,
  onLogoError,
  orgName = '',
}) {
  const navigate = useNavigate();

  return (
    <nav className="hair-report-nav">
      <button type="button" onClick={onBack} className="hair-report-nav-btn back-btn" aria-label="Go back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>

      <div className="hair-report-nav-center">
        {(showLogo || orgName) ? (
          <div className="hair-report-nav-brand">
            <HairSalonBrandLogo
              showLogo={showLogo}
              orgLogoUrl={orgLogoUrl}
              onLogoError={onLogoError}
              className="hair-report-nav-logo"
              imgClassName="hair-report-nav-logo-img"
              fallbackClassName="hair-report-nav-logo-fallback"
              alt={orgName || 'Salon'}
            />
            {orgName ? <span className="hair-report-nav-org">{orgName}</span> : null}
          </div>
        ) : null}
        <h1 className="hair-report-title">Hair Analysis &amp; Routine</h1>
        <span className="hair-report-timestamp">
          Generated: {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </span>
      </div>

      <div className="hair-report-nav-right">
        <button
          type="button"
          className="hair-report-cart-pill"
          onClick={() => navigate(pathWithSessionId('/product-recommendations', sessionId), { state: locationState })}
        >
          <span className="cart-icon">🛒</span>
          <span className="cart-count">{cartCount}</span>
        </button>
        <button type="button" onClick={onHome} className="hair-report-nav-btn home-btn" aria-label="Home">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        </button>
      </div>
    </nav>
  );
}
